import { ApplicationConfig, importProvidersFrom, isDevMode, provideBrowserGlobalErrorListeners, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { provideServiceWorker } from '@angular/service-worker';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { HttpService } from './commons/services/http.service';
import { AppModule } from './app-module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from './commons/shared/AuthInterceptor';
import { errorInterceptor } from './commons/shared/error.interceptor';


  export const appConfig: ApplicationConfig = {
    providers: [
      provideClientHydration(),
      provideBrowserGlobalErrorListeners(),
      provideZonelessChangeDetection(),
      provideRouter(routes, withHashLocation()),
      provideClientHydration(withEventReplay()),
      provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
      }),
      provideHttpClient(
        withInterceptors([
          authInterceptor,
          errorInterceptor
        ])
      ),
      { provide: 'env', useValue: environment },
      importProvidersFrom(AppModule),
      HttpService,
      provideAnimations()
    ]
  };
